import {NgModule} from '@angular/core';
import {OrdersListComponent} from './orders/orders-list/orders.list.component';
import {CreateDeliveryNoteComponent} from './orders/overlays/create-delivery-note/create.delivery.note.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule, DatePipe} from '@angular/common';
import {RouterModule} from '@angular/router';
import {DeliveryNotesListComponent} from './orders/delivery.notes.list.component';
import {ProjectStatusComponent} from './orders/project-status/project.status.component';
import {ProjectStatusExternalComponent} from './orders/project-status/project.status.external.component';
import {EtaDocumentsComponent} from './orders/eta/eta.documents.component';
import {
  CommissionBottomsheetComponent
} from './orders/overlays/commission-bottomsheet/commission.bottomsheet.component';
import {ProjectStatusInternalComponent} from './orders/project-status/project.status.internal.component';
import {OrderOverviewComponent} from './orders/orders-overview/order.overview.component';
import {PositionCardTlComponent} from './orders/position/tl/position.card.tl.component';
import {PositionCardBmComponent} from './orders/position/bm/position.card.bm.component';
import {ChangedOverlayComponent} from './orders/overlays/changed-overlay/changed.overlay.component';
import {ProleisSuppliersStoreModule} from './store/proleis.suppliers.store.module';
import {PositionCardTpComponent} from './orders/position/tp/position.card.tp.component';
import {PlannedDeliveriesComponent} from './orders/deliveries/planned.deliveries.component';
import {
  CreatePlannedDeliveryComponent
} from './orders/overlays/create-planned-delivery/create.planned.delivery.component';
import {EditPlannedDeliveryComponent} from './orders/overlays/edit-planned-delivery/edit.planned.delivery.component';
import {HighchartsChartModule} from 'highcharts-angular';
import {SearchPositionDialogComponent} from './orders/search-position/search.position.dialog.component';
import {IncidentsListComponent} from './incidents/incidents-list/incidents.list.component';
import {IncidentDetailsComponent} from './incidents/incident-details/incident.details.component';
import {ProleisWebGalleryModule} from '@proleis/proleis-web-gallery';
import {CreateCommentComponent} from './incidents/create-comment/create.comment.component';
import {PlannedDeliveryComponent} from './orders/deliveries/planned-delivery/planned.delivery.component';
import {PositionCardPmComponent} from './orders/position/pm/position.card.pm.component';
import {PmDocumentsComponent} from './orders/position/pm/documents/pm.documents.component';
import {UploadPmDocumentComponent} from './orders/position/pm/documents/dialogs/upload.pm.document.component';
import {FileInputModule} from '@proleis/proleis-web-file-input';
import {PmConstructionsComponent} from './change/pm-constructions/pm-constructions.component';
import {PmSnrsComponent} from './change/pm-snrs/pm-snrs.component';
import {PmSnrDocumentsComponent} from './change/pm-documents/pm-snr-documents.component';
import {PmCreateIndexComponent} from './change/pm-create-index/pm-create-index.component';
import {PmCreateSnrComponent} from './change/pm-create-snr/pm-create-snr.component';
import {PmImportPrismaDocumentsComponent} from './change/pm-prisma-documents/pm-import-prisma-documents.component';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatCardModule} from '@angular/material/card';
import {MatTabsModule} from '@angular/material/tabs';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatBadgeModule} from '@angular/material/badge';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatRadioModule} from '@angular/material/radio';
import {MatMenuModule} from '@angular/material/menu';
import {PmImportPrismaObjectsComponent} from './change/pm-import-prisma-objects/pm-import-prisma-objects.component';
import {TranslateModule} from '@ngx-translate/core';
import {
  UploadToolacceptanceReportComponent
} from './orders/position/bm/upload-tool-acceptance-report/upload-toolacceptance-report.component';
import {ContactsListComponent} from './contacts/contacts-list/contacts.list.component';
import {ContactsDetailsComponent} from './contacts/contacts-details/contacts.details.component';
import {CreateAddressComponent} from './contacts/create-address/create-address.component';
import {CreateConnectionComponent} from './contacts/create-connection/create-connection.component';
import {CreateContactComponent} from './contacts/create-contact/create-contact.component';
import {ConfirmDialogComponent} from './dialogs/confirm-dialog.component';
import {PmProjectStatusComponent} from './orders/project-status/pm/pm-project-status.component';
import {MultiEditPmStatusComponent} from './orders/project-status/pm/multi-edit-pm-status.component';
import {PmMultiProjectStatusComponent} from './orders/project-status/pm/pm-multi-project-status.component';
import {PmCreateCommentComponent} from './change/pm-create-comment/pm-create-comment.component';
import {PmPositionListComponent} from './orders/position/pm/pm-position-list/pm-position-list.component';
import {
  UploadInspectionReportComponent
} from './orders/position/pm/upload-inspection-report/upload-inspection-report.component';
import {BlanksOverviewComponent} from './orders/position/bm/blanks-overview/blanks-overview.component';
import {CreateBlankStatusComponent} from './orders/position/bm/create-blank-status/create-blank-status.component';
import {UpdateMeasureDialogComponent} from './orders/position/bm/update-measure-dialog/update-measure-dialog.component';
import {
  UploadMeasurementProtocolComponent
} from './orders/position/tl/upload-measurement-protocol/upload-measurement-protocol.component';
import {RibbonsModule} from "@proleis/proleis-web-ribbons";
import {
  PmConstructionsListComponent
} from './change/pm-constructions/pm-constructions-list/pm-constructions-list.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {ProleisWebAppModule} from "@proleis/proleis-web-app";

@NgModule({
  imports: [
    ProleisSuppliersStoreModule,
    ProleisWebAppModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatInputModule,
    MatCardModule,
    MatTabsModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatSelectModule,
    MatDialogModule,
    MatBadgeModule,
    HighchartsChartModule,
    MatAutocompleteModule,
    MatRadioModule,
    ProleisWebGalleryModule,
    RibbonsModule,
    MatMenuModule,
    MatSortModule,
    FileInputModule,
    TranslateModule,
    RibbonsModule,
    MatExpansionModule,
    RibbonsModule,
    MatButtonToggleModule
  ],
  declarations: [
    OrdersListComponent,
    CreateDeliveryNoteComponent,
    DeliveryNotesListComponent,
    ProjectStatusComponent,
    ProjectStatusExternalComponent,
    ProjectStatusInternalComponent,
    EtaDocumentsComponent,
    CommissionBottomsheetComponent,
    OrderOverviewComponent,
    PositionCardTlComponent,
    PositionCardBmComponent,
    PositionCardPmComponent,
    PositionCardTpComponent,
    PmDocumentsComponent,
    UploadPmDocumentComponent,
    ChangedOverlayComponent,
    PlannedDeliveriesComponent,
    CreatePlannedDeliveryComponent,
    EditPlannedDeliveryComponent,
    SearchPositionDialogComponent,
    IncidentsListComponent,
    IncidentDetailsComponent,
    CreateCommentComponent,
    PlannedDeliveryComponent,
    PmConstructionsComponent,
    PmSnrsComponent,
    PmSnrDocumentsComponent,
    PmCreateIndexComponent,
    PmCreateSnrComponent,
    PmImportPrismaObjectsComponent,
    PmImportPrismaDocumentsComponent,
    UploadToolacceptanceReportComponent,
    ContactsListComponent,
    ContactsDetailsComponent,
    CreateAddressComponent,
    CreateConnectionComponent,
    CreateContactComponent,
    ConfirmDialogComponent,
    PmProjectStatusComponent,
    MultiEditPmStatusComponent,
    PmMultiProjectStatusComponent,
    PmCreateCommentComponent,
    PmPositionListComponent,
    UploadInspectionReportComponent,
    BlanksOverviewComponent,
    CreateBlankStatusComponent,
    UpdateMeasureDialogComponent,
    UploadMeasurementProtocolComponent,
    PmConstructionsListComponent
  ],
  exports: [
    OrdersListComponent,
    CreateDeliveryNoteComponent,
    DeliveryNotesListComponent,
    ProjectStatusComponent,
    EtaDocumentsComponent,
    CommissionBottomsheetComponent,
    OrderOverviewComponent,
    PositionCardTlComponent,
    PositionCardBmComponent,
    PositionCardTpComponent,
    PositionCardPmComponent,
    PmDocumentsComponent,
    UploadPmDocumentComponent,
    ChangedOverlayComponent,
    PlannedDeliveriesComponent,
    CreatePlannedDeliveryComponent,
    EditPlannedDeliveryComponent,
    SearchPositionDialogComponent,
    IncidentsListComponent,
    IncidentDetailsComponent,
    CreateCommentComponent,
    PlannedDeliveryComponent,
    PmConstructionsComponent,
    PmSnrsComponent,
    PmSnrDocumentsComponent,
    PmCreateIndexComponent,
    PmCreateSnrComponent,
    PmImportPrismaObjectsComponent,
    UploadToolacceptanceReportComponent,
    ContactsListComponent,
    ContactsDetailsComponent,
    CreateAddressComponent,
    CreateConnectionComponent,
    CreateContactComponent,
    ConfirmDialogComponent,
    PmProjectStatusComponent,
    MultiEditPmStatusComponent,
    PmMultiProjectStatusComponent,
    PmCreateCommentComponent
  ],
  providers: [
    DatePipe
  ]
})

export class SuppliersModule {

}
